import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

export function NextServiceDatePicker() {
  return (
    <Field
      type="apiDate"
      name="nextServiceDate"
      label={i18n.t('entity.vehicle.labels.nextService')}
      tooltip={i18n.t('entity.vehicle.labels.nextServiceTooltip')}
    />
  );
}
